import { FC, useState } from 'react';
import { useSendCode } from 'src/hooks/ForgetPassword/UseSendCode';
import { useConfirmResetPassword } from 'src/hooks/ForgetPassword/useConfirmResetPassword';
import { FirstStep } from './FirstStep/FirstStep';
import { SecondStep } from './SecondStep/SecondStep';
import { ThirdStep } from './ThirdStep/ThirdStep';

interface ForgotPasswordTypeProps {
  goToLogin: () => void;
}

enum ForgotPasswordStep {
  ResetRequest = 1,
  ResetVerification = 2,
  ResetComplete = 3,
}

export const ForgetPasswordType: FC<ForgotPasswordTypeProps> = ({
  goToLogin,
}) => {
  const [step, setStep] = useState<number>(ForgotPasswordStep.ResetRequest);

  const {
    phoneNumber,
    setPhoneNumber,
    sendCode,
    loading: sendCodeLoading,
    error: sendCodeError,
  } = useSendCode();

  const {
    code,
    setCode,
    newPassword,
    setNewPassword,
    confirmResetPassword,
    loading: resetPasswordLoading,
    error: confirmResetPasswordError,
  } = useConfirmResetPassword();

  const handleSendCode = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    try {
      // Reset password only uses code verification
      await sendCode();
      setStep(ForgotPasswordStep.ResetVerification);
    } catch (err) {
      console.error('Error occurred during password reset', err);
    }
  };

  const handleConfirmResetPassword = async (
    event: React.FormEvent<HTMLFormElement>
  ) => {
    event.preventDefault();

    try {
      await confirmResetPassword(phoneNumber);
      setStep(ForgotPasswordStep.ResetComplete);
    } catch (err) {
      console.error('Error occurred during password reset confirmation', err);
    }
  };

  const renderStep = () => {
    switch (step) {
      case ForgotPasswordStep.ResetRequest:
        return (
          <FirstStep
            phoneNumber={phoneNumber}
            setPhoneNumber={setPhoneNumber}
            handleSendCode={handleSendCode}
            loading={sendCodeLoading}
            error={sendCodeError}
            goToLogin={goToLogin}
          />
        );
      case ForgotPasswordStep.ResetVerification:
        return (
          <SecondStep
            code={code}
            newPassword={newPassword}
            setCode={setCode}
            setNewPassword={setNewPassword}
            handleConfirmResetPassword={handleConfirmResetPassword}
            loading={resetPasswordLoading}
            error={confirmResetPasswordError}
            goToLogin={goToLogin}
          />
        );
      case ForgotPasswordStep.ResetComplete:
        return <ThirdStep goToLogin={goToLogin} />;
    }
  };

  return <>{renderStep()}</>;
};
